import React, { useState } from 'react';
import c from '../../constants/Colors';
import { data } from '../../constants/Constants';

function CardPrecioOferta(props) {

    let getClassNameForPrice = (item, data) => {
        if (item.codigo) {
            switch (item.tipo) {
                case data.PrecioOfe:
                    return { color: '#fff' };
                case data.PrecioFin:
                    return { color: '#fff', fontFamily: 'gotham-bold', };
                case data.PrecioPub:
                    return { color: '#fff' };
                default:
                    return { color: '#fff' };
            }
        } else {
            switch (item.tipo) {
                case data.PrecioOfe:
                    return { color: '#fff', };
                case data.PrecioFin:
                    return { color: '#fff', fontFamily: 'gotham-bold'};
                case data.PrecioPub:
                    return { color: '#fff', textDecorationLine: 'line-through', };
                default:
                    return { color: '#fff', };
            }
        }
    }

    return (
        <div className={props.className}>
            {props.data.map((item, index) => {
                return (
                    <span key={index} style={getClassNameForPrice(item, data)} >{item.precioStr}</span>
                )
            })}
        </div>
    );
}

export default CardPrecioOferta;  